import React from 'react';
import T from 'i18n-react';

import DropDown, { DropDownPropTypes } from './components/DropDown';

const CategoryDropDown = ({ ...restProps }) => (
  <DropDown
    {...restProps}
    label={T.translate('new.category')}
    valueKey="key"
    placeholder={T.translate('filter.category')}
  />
);

// eslint-disable-next-line no-unused-vars
const { label, placeholder, valueKey, searchIcon, ...CategoryDropDownPropTypes } = DropDownPropTypes;

CategoryDropDown.propTypes = CategoryDropDownPropTypes;
export default CategoryDropDown;
